import { HStack, Link } from '@chakra-ui/react';

const TextLinkIcon = ({ href, children }) => {
  return (
    <Link href={href} color="NAVY">
      <HStack>{children}</HStack>
    </Link>
  );
};

export default TextLinkIcon;
